<template>
  <div class="competition-standings-filter">
    <div
      v-if="rules.length > 0"
      :class="{ selected: activeFilter.category === 'individual' }"
      @click="
        $emit('select', {
          category: 'individual',
          index: activeFilterDefaultIndex,
        })
      "
    >
      {{ $t('competition-standings-filter.individual') }}
    </div>

    <div
      v-if="teamSizes.length > 0"
      :class="{ selected: activeFilter.category === 'teams' }"
      @click="$emit('select', { category: 'teams', index: 0 })"
    >
      {{ $t('competition-standings-filter.teams') }}
    </div>

    <span v-if="rules.length + teamSizes.length > 0">•</span>

    <template v-if="activeFilter.category === 'individual'">
      <div
        v-for="(rule, index) in rules"
        :key="index"
        :class="{ selected: index === activeFilter.index }"
        @click="$emit('select', { category: 'individual', index })"
      >
        <span>{{ rule }}</span>
      </div>
    </template>

    <template v-if="activeFilter.category === 'teams'">
      <div
        v-for="(teamSize, index) in teamSizes"
        :key="index"
        :class="{ selected: index === activeFilter.index }"
        @click="$emit('select', { category: 'teams', index })"
      >
        <span>{{ teamSize }}</span>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

export interface ActiveFilterOpts {
  category: string
  index: number
}

defineProps({
  rules: {
    type: Array as PropType<string[]>,
    default: () => [],
  },

  teamSizes: {
    type: Array as PropType<string[]>,
    default: () => [],
  },

  activeFilter: {
    type: Object as PropType<ActiveFilterOpts | null>,
    required: true,
  },

  activeFilterDefaultIndex: {
    type: Number as PropType<number>,
    default: 0,
  },
})

defineEmits(['select'])
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.competition-standings-filter {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 1em;
  user-select: none;

  > div {
    min-width: 5em;
    padding: 0.75em 1em;
    border-radius: 0.5em;
    background-color: $color-background-disabled;
    text-align: center;
    cursor: pointer;
    transition: opacity $default-transition;

    &:hover {
      opacity: 0.7;
    }

    &.selected {
      background-color: $color-accent;
      color: $color-text-inverted;
    }
  }
}
</style>
